module.exports = __webpack_public_path__ + "static/media/notification.f524b550.svg";